import { ExpeditionType } from "store/apis/expeditionsAPI"

export const expeditionsOrder: Record<ExpeditionType, number> = {
  lake: 1,
  forest: 2,
  mountains: 3,
  winter_expedition: 4,
  love_day_expedition: 5,
  summer_expedition: 6
}

export const expeditionsDeprecated = [
  "winter_expedition",
  "love_day_expedition"
]
